"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityUpdateDto = instanceOfFacilityUpdateDto;
exports.FacilityUpdateDtoFromJSON = FacilityUpdateDtoFromJSON;
exports.FacilityUpdateDtoFromJSONTyped = FacilityUpdateDtoFromJSONTyped;
exports.FacilityUpdateDtoToJSON = FacilityUpdateDtoToJSON;
exports.FacilityUpdateDtoToJSONTyped = FacilityUpdateDtoToJSONTyped;
const AddressCreateDto_1 = require("./AddressCreateDto");
/**
 * Check if a given object implements the FacilityUpdateDto interface.
 */
function instanceOfFacilityUpdateDto(value) {
    return true;
}
function FacilityUpdateDtoFromJSON(json) {
    return FacilityUpdateDtoFromJSONTyped(json, false);
}
function FacilityUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'website': json['website'] == null ? undefined : json['website'],
        'address': json['address'] == null ? undefined : (0, AddressCreateDto_1.AddressCreateDtoFromJSON)(json['address']),
    };
}
function FacilityUpdateDtoToJSON(json) {
    return FacilityUpdateDtoToJSONTyped(json, false);
}
function FacilityUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'website': value['website'],
        'address': (0, AddressCreateDto_1.AddressCreateDtoToJSON)(value['address']),
    };
}
//# sourceMappingURL=FacilityUpdateDto.js.map